<template>
  <div>
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <div class="watermark">
            <img v-if="invoiceHeader" :src="getFileServerUrl + employeeDetails?.branch?.company?.watermark" alt="">
          </div>

          <div class="letter-container">
            <div class="letter-content">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr v-if="invoiceHeader">
                    <td colspan="100%">
                      <img :src="getFileServerUrl + employeeDetails?.branch?.company?.header_image" style="width: 100%; height: auto;" alt="">
                    </td>
                  </tr>
                </thead>
                
                <tbody>
                  <tr>
                    <td colspan="100%" style="border: none; padding: 25px; vertical-align: top;">
                      <div style="font-family: sans-serif; font-size: 13px; line-height: 1.6;">
                        
                        <div style="margin-bottom: 15px;">
                          <p style="margin: 0;"><strong>Date: {{ getCurrentDate }}</strong></p>
                        </div>

                        <div style="margin-bottom: 10px;">
                          <p>To,</p>
                          <p><strong>{{ employeeDetails?.name }}</strong></p>
                          <p>{{ employeeDetails?.designation?.name }}</p>
                          <p>{{ employeeDetails?.department?.name }}</p>
                          <p>{{ employeeDetails?.branch?.company?.name }}</p>
                        </div>

                        <div style="margin-bottom: 10px;">
                          <p style="margin: 0;"><strong>Subject: {{ employeeDetails?.increment_details?.increment_type }} Salary Increment</strong></p>
                        </div>

                        <div style="margin-bottom: 10px;">
                          <p style="margin: 0 0 12px 0;"><strong>Dear {{ employeeDetails?.name }},</strong></p>

                          <p style="margin: 0 0 12px 0; text-align: justify;">
                            We are pleased to inform you that based on your performance review and in recognition of your significant contribution to the organization, the management has approved a {{ employeeDetails?.increment_details?.increment_type }} increment to your salary in accordance with the company's compensation policy.
                          </p>

                          <p style="margin: 0 0 12px 0;"><strong>Your revised salary structure</strong>, effective from <strong>{{ formatDateView(employeeDetails?.increment_details?.effect_date) }}</strong>, is as follows:</p>

                          <p style="margin: 0 0 12px 0;"><strong>Monthly Salary Breakup:</strong></p>
                          <div style="margin: 0 0 12px 10px;">
                            <p>• <strong>Basic Salary:</strong> {{ employeeDetails?.increment_details?.after_basic || "-" }}</p>
                            <p>• <strong>House Rent Allowance (HRA):</strong> {{ employeeDetails?.increment_details?.after_house_rent || "-" }}</p>
                            <p>• <strong>Conveyance Allowance:</strong> {{ employeeDetails?.increment_details?.after_conveyance  || "-" }}</p>
                            <p>• <strong>Medical Allowance:</strong> {{ employeeDetails?.increment_details?.after_medical || "-" }}</p>
                            <p>• <strong>Other Allowances (if any):</strong> {{ employeeDetails?.increment_details?.after_others || "-" }}</p>
                          </div>

                          <p style="margin: 0 0 12px 0;"><strong>Gross Monthly Salary: {{ employeeDetails?.increment_details?.after_gross_salary || "-" }}</strong></p>

                          <p style="margin: 0 0 12px 0; text-align: justify;">
                            This revision has been made as per the <strong>Management and Compensation Policy of {{ employeeDetails?.branch?.company?.name }}</strong>, and is subject to applicable statutory deductions and company rules in force from time to time.
                          </p>

                          <p style="margin: 0 0 12px 0;">All other terms and conditions of your employment remain unchanged.</p>

                          <p style="margin: 0 0 12px 0; text-align: justify;">
                            We appreciate your efforts and look forward to your continued excellence and growth with <strong>{{ employeeDetails?.branch?.company?.name }}</strong>.
                          </p>
                        </div>

                        <div >
                          <p style="margin: 0;">Warm regards,</p>
                        </div>

                        <div>
                          <p style="margin: 0;">From {{ employeeDetails?.branch?.company?.name }}</p>
                        </div>

                        <div :style="{marginTop: withSignature? '0': '100px'}">
                          <img v-if="withSignature" style="height: 100px !important;" :src="`${getFileServerUrl}` + 'uploads/images/company/signature-without-bg.png'" alt="">
                          <p style="text-transform: capitalize; font-weight: bold;">Date: {{ formatDateView(new Date) }}</p>
                          <p style="border-bottom: 1px solid #000; width: 250px;"></p>
                          <p><strong>{{ employeeDetails?.branch?.company?.company_owner_name }}</strong></p>
                          <p><strong>{{ employeeDetails?.branch?.company?.owner_designation?.name }}</strong></p>
                          <p>{{ employeeDetails?.department?.name }}</p>
                        </div>

                      </div>
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr v-if="invoiceHeader">
                    <td colspan="100%" style="border:none">
                      <div style="width:100%;height: 80px;">&nbsp;</div>
                    </td>
                  </tr>
                </tfoot>

              </table>
            </div>

            <div class="invoice-footer">
              <img v-if="invoiceHeader" :src="getFileServerUrl + employeeDetails?.branch?.company?.footer_image" alt="" style="width: 100%; display: block; margin-bottom:-15px;">
            </div>
          </div>

        </v-sheet>
      </v-col>
      <v-col cols="12">
          <v-checkbox
          label="With signature"
          v-model="withSignature"
          density="compact"
          variant="outlined"
          hide-details
          single-line
          color="primary"
          :true-value="1"
          :false-value="0"
          ></v-checkbox>
      </v-col>
      <v-col cols="12" style="display: flex; justify-content: end;">
        <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
          Print without pad
        </v-btn>
        <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
          Print with pad
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { formatDateView, formatDateDash } from "@/plugins/helpers";

export default {
  name: "hrm-employee-increment-letter",
  props: {
    employeeDetails: Object,
    getFileServerUrl: String,
    getCurrentDate: String,
    incrementEffectiveDate: String,
    salaryDetails: Object,
  },
  data() {
    return {
      withSignature: 1,
      invoiceHeader: true,
      pagePadding: 0,
    };
  },
  methods: {
    formatDateView,
    print(isPad) {
      if (isPad === 1) {
        this.invoiceHeader = true;
        this.pagePadding = 0;
      } else if (isPad === 0) {
        this.invoiceHeader = false;
        this.pagePadding = 80;
      }

      setTimeout(() => {
        const printContent = document.getElementById("printable-area").innerHTML;
        const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);

        printWindow.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Increment Letter</title>
          <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          @page {
            size: A4;   
            margin: ${this.pagePadding}px 0;
          }

          html, body {
            margin: 0;
            padding: 0;
            width: 100%;
            height: auto;
          }

          body { 
            font-family: sans-serif; 
            background: #fff; 
            color: #000; 
            -webkit-print-color-adjust: exact; 
            print-color-adjust: exact;
            margin: 0;
            padding: 0;
          }

          .report-paper { 
            width: 100%; 
            padding: 0 !important;
            background: #fff;
            margin: 0;
          }

          .letter-container {
            width: 100%;
            margin: 0;
            padding: 0;
          }

          .letter-content {
            width: 100%;
            margin: 0;
            padding: 0;
            overflow: visible;
          }

          table {
            width: 100%;
            margin: 0;
            padding: 0;
            border-collapse: collapse;
          }

          thead {
            display: table-header-group;
            page-break-inside: avoid;
          }

          .invoice-footer {
            margin-top: auto;
            position: fixed;
            left: 0;
            bottom: 15px;
            width: 100%;    
          }

          tbody {
            page-break-inside: avoid;
          }

          .watermark {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 0;
          }

          img { 
            max-width: 100% !important; 
            height: auto !important; 
            display: block;
          }

          .text-center { text-align: center; }
          .text-right { text-align: right; }
          .text-left { text-align: left; }
          
          .mt-4 { margin-top: 16px !important; }
          .pa-6 { padding: 24px !important; }

          .d-print-none {
            display: none !important;
          }

          @media print { 
            body {
              margin: 0;
              padding: 0;
            }

            .report-paper {
              margin: 0;
              padding: 0;
            }

            thead {
              display: table-header-group;
              page-break-inside: avoid;
              page-break-after: avoid;
            }

            tfoot {
              display: table-footer-group;
              page-break-inside: avoid;
              page-break-before: avoid;
            }

            tbody {
              page-break-inside: avoid;
            }

            table {
              page-break-inside: auto;
            }

            tr {
              page-break-inside: avoid;
              page-break-after: auto;
            }

            .watermark {
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              z-index: 0;
            }
          }
          </style>
          </head>
          <body>
            ${printContent}
          </body>
          </html>
        `);

        printWindow.document.close();
        printWindow.focus();

        setTimeout(() => {
          printWindow.print()
        }, 500);
        this.invoiceHeader = true;
        this.pagePadding = 0;
      }, 500);
    }
  },
};
</script>

<style scoped>
body, html {
  font-family: sans-serif;
}
.full-height { 
  min-height: 60vh; 
}
.grey-lighten-3 { 
  background-color: #eeeeee !important; 
}
.report-paper { 
  background: white; 
}
.letter-container { 
  width: 100%; 
}
.text-center { 
  text-align: center; 
}
.text-right { 
  text-align: right; 
}
.text-left { 
  text-align: left; 
}
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.d-print-none {
  display: block !important;
}

.justify-end {
  justify-content: flex-end;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>